<template>
  <div class="options__wrapper" v-if="currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length">
    <template v-for="option in currentProductInPopup.product_options" :key="option.id">
      <div class="option">
        <div class="optionTitle">
          <p>{{option.name}}</p>
          <div class="minMax" v-if="option.type == 'radio' && option.values.length > 1 && option.required">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
              <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="red" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <div>
              <span>{{$t('addOrder.selectMinMax')}}</span>
              <span>{{$t('addOrder.selectMin')}} 1</span>
            </div>
          </div>
          <div class="minMax" v-if="option.min_no || option.max_no">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
              <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="red" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <div>
              <span>{{$t('addOrder.selectMinMax')}}</span>
              <span v-if="option.min_no">{{$t('addOrder.selectMin')}} {{option.min_no}}</span>
              <span v-if="option.max_no">{{$t('addOrder.selectMax')}} {{option.max_no}}</span>
            </div>
          </div>
        </div>
        <div :class="[
            'options',
            option.show_type_kiosk == 'default' ? 'withPhoto' : ''
          ]">
          <div v-for="(values, keyVal) in option.values" :key="values.id"
          :class="[
            option.show_type_kiosk == 'default' ? 'withPhoto' : 'defaultOption'
          ]">
            <label :for="values.id">
              <!-- ==================== CHECKBOX WITH QUANTITY ==================== -->
              <template v-if="(option.type === 'checkbox')">
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :disabled="values.disabled"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="values.checked"
                >
                <button @click="clickOnRef('ref_' + values.id)" :class="values.disabled ? 'disabled' : ''">
                  <div class="topOneLine">
                    <template v-if="option.show_type_kiosk == 'default'">
                      <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'"></div>
                    </template>

                    <span class="name">{{values.name}}</span>
                    <span v-if="getAvailableStock(values) !== false" class="option_stock_badge">
                      <template v-if="getAvailableStock(values) > 99">{{$t('addOrder.sufficientStock')}}</template>
                      <template v-else>{{getAvailableStock(values)}} {{$t('addOrder.available')}}</template>
                    </span>

                    <template v-if="!option.hide_prices">
                      <span class="price" v-if="values.price > 0" v-html="'+ ' + (values.price * (values.quantity || 1)) + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                    </template>
                  </div>

                  <!-- Quantity Selector - Only for checkbox with allow_quantity -->
                  <template v-if="values.company_option_value && values.company_option_value.allow_quantity && values.checked">
                    <div class="quantity-wrapper" @click.stop>
                      <quantity-selector
                        :value="values.quantity || 1"
                        :min="values.company_option_value.min_quantity || 1"
                        :max="getOptionValueMaxQuantity(option, values)"
                        @change="updateQuantityOptions(option.id, values, $event)"
                      />
                    </div>
                  </template>

                  <div class="bottomOneLine">
                    <template v-if="option.show_type_kiosk == 'default'">
                      <template v-if="values.company_option_value && values.company_option_value.cov_info && values.company_option_value.cov_info != '' && values.company_option_value.cov_info != '<br>'">
                        <p class="showInfo" @click.stop="emitCallFunction('openInfoPopupForOption', values)" style="text-align: center; padding: 5px 20px; border-radius: 20px; margin-bottom: 10px; text-decoration: underline; text-transform: none; margin-top: 10px; font-size: 1rem;">info. nutriționale</p>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="values.company_option_value && values.company_option_value.cov_info && values.company_option_value.cov_info != '' && values.company_option_value.cov_info != '<br>'">
                        <p class="showInfo" @click.stop="emitCallFunction('openInfoPopupForOption', values)" style="text-align: center; text-transform: none; text-decoration: underline; margin-top: 10px; font-size: 1rem;">info. nutriționale</p>
                      </template>
                    </template>
                  </div>
                </button>
              </template>

              <!-- ==================== RADIO (no quantity) ==================== -->
              <template v-else>
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :disabled="values.disabled"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="option.checked"
                >
                <button @click="clickOnRef('ref_' + values.id)" :class="values.disabled ? 'disabled' : ''">
                  <div class="topOneLine">
                    <template v-if="option.show_type_kiosk == 'default'">
                      <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'"></div>
                    </template>
                    <span class="name">{{values.name}}</span>
                    <span v-if="getAvailableStock(values) !== false" class="option_stock_badge">
                      <template v-if="getAvailableStock(values) > 99">{{$t('addOrder.sufficientStock')}}</template>
                      <template v-else>{{getAvailableStock(values)}} {{$t('addOrder.available')}}</template>
                    </span>
                    <template v-if="!option.hide_prices">
                      <span class="price" v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                    </template>
                  </div>

                  <div class="bottomOneLine">
                    <template v-if="option.show_type_kiosk == 'default'">
                      <template v-if="values.company_option_value && values.company_option_value.cov_info && values.company_option_value.cov_info != '' && values.company_option_value.cov_info != '<br>'">
                        <p class="showInfo" @click.stop="emitCallFunction('openInfoPopupForOption', values)" style="text-align: center; padding: 5px 20px; border-radius: 20px; margin-bottom: 10px; text-decoration: underline; text-transform: none; margin-top: 10px; font-size: 1rem;">info. nutriționale</p>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="values.company_option_value && values.company_option_value.cov_info && values.company_option_value.cov_info != '' && values.company_option_value.cov_info != '<br>'">
                        <p class="showInfo" @click.stop="emitCallFunction('openInfoPopupForOption', values)" style="text-align: center; text-transform: none; text-decoration: underline; margin-top: 10px; font-size: 1rem;">info. nutriționale</p>
                      </template>
                    </template>
                  </div>
                </button>
              </template>
            </label>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
import QuantitySelector from './QuantitySelector.vue'

export default {
  mixins: [utilsMixin],
  name: 'ProductOptions',
  components: {
    QuantitySelector
  },
  props: {
    currentProductInPopup: Array,
    stocksForProductOptions: Object,
    productOptionsCovStockMap: Object
  },
  data () {
    return {

    }
  },
  mounted() {

  },
  created () {

  },
  methods: {
    getAvailableStock (value) {
      if (!value) return false

      const stockProductId = value.company_option_value_id != null && this.productOptionsCovStockMap && this.productOptionsCovStockMap[value.company_option_value_id] != null
        ? this.productOptionsCovStockMap[value.company_option_value_id]
        : value.company_option_value && value.company_option_value.product_id
      const stockData = stockProductId != null && this.stocksForProductOptions
        ? this.stocksForProductOptions[stockProductId]
        : null
      const stock = stockData && stockData.in_stock !== false && stockData.stock && stockData.stock.id
        ? Number(stockData.stock.stock)
        : 0

      return stock > 0 ? stock : false
    },
    updateCategories (opId, valId) {
      this.$emit('updateCategories', opId, valId);
    },
    emitCallFunction (functionName, params) {
      this.$emit('callFromOptions', functionName, params);
    },
    updateQuantityOptions(opId, values, newQuantity) {
      // Update the quantity on the value object
      // Vue.set(values, 'quantity', newQuantity);
      values.quantity = newQuantity;
      // Emit to parent so it can recalculate totals
      // this.$emit('quantityChanged', values.id, newQuantity);

      this.$emit('updateCategories', opId, values.id);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .topOneLine {
    display: flex;
  }
  .withPhoto {
    .topOneLine {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .bottomOneLine {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
  }
  .option_stock_badge {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 4px 0 0;
    padding: 4px 9px !important;
    border-radius: 999px;
    background: #e9f7ee;
    color: #237a42 !important;
    font-size: 0.88rem !important;
    font-weight: 700 !important;
    line-height: 1.1;
    white-space: nowrap;
  }
  .options input:checked ~ button .option_stock_badge {
    background: rgba(255, 255, 255, 0.22);
    color: #fff !important;
  }

  /* ===== QUANTITY SELECTOR STYLES ===== */
  .quantity-wrapper {
    display: flex;
    justify-content: center;
    padding: 8px 0;
    margin-top: 5px;
  }

  /* Animation for quantity selector appearance */
  .quantity-wrapper {
    animation: slideDown 0.25s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Adjust button layout when quantity selector is present */
  .options > div label button {
    flex-direction: column;
  }

  .mobile {
    .options__wrapper {
      padding-bottom: 0;
      .option {
        .minMax {
          background: transparent;
          border: 0;
          padding: 0;
        }
        .options {
          button {
            margin-bottom: 10px;
            min-height: auto;
            padding: 0px;
            border-radius: 10px;
            overflow: hidden;
            .opt_photo {
              height: 100px;
              @media screen and (max-width: 420px) {
                // height: 70px;
              }
            }
          }
          &.withPhoto {
            margin-left: -10px;
            margin-right: -10px;
          }
          .withPhoto {
            width: calc(33.33% - 20px);
            margin-right: 10px;
            margin-left: 10px;
            @media screen and (max-width: 420px) {
              width: calc(50% - 20px);
            }
          }
          &>div {
            margin-right: 10px;
          }
        }
        @media screen and (max-width: 400px) {
          .optionTitle {
            flex-direction: column;
            align-items: flex-start;
            .minMax {
              margin: 0;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
  .options__wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;
    z-index: 2;
    position: relative;
    p {
      font-size: 1.62rem;
      font-weight: 500;
      text-align: left;
      margin: 0;
      text-transform: uppercase;
    }
    .option {
      margin-bottom: 20px;
      .defaultOption {
        button {
          display: flex;
          flex-direction: column;
        }
      }
      .options.withPhoto {
        button {
          border: 4px solid transparent;
          .name {
            min-height: 55px;
          }
          .price {
            font-weight: bold;
          }
        }
        input:checked ~ button {
          border: 4px solid var(--principal) !important;
          background-color: #fff;
          color: #000;
          span {
            span {
              color: #000;
            }
          }
        }
      }
      .optionTitle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 10px;
      }
      .minMax {
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EBEBEB;
        border: 1px solid #E3E3E3;
        border-radius: 10px;
        padding: 5px 15px;
        svg {
          margin-right: 5px;
        }
        span {
          font-size: 1.2rem;
          font-weight: 500;
          color: red;
        }
      }
      .options {
        display: flex;
        flex-wrap: wrap;
        button {
          border-radius: 15px;
          background: #fff;
          color: #000;
          border: 1px solid var(--principal);
          margin-bottom: 20px;
          padding: 10px 15px;
          min-height: 48px;
          width: 100%;
          &.disabled {
            opacity: 0.5;
          }
          .opt_photo {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            width: 100%;
            height: 150px;
            max-width: 150px;
          }
        }
        .withPhoto {
          width: calc(25% - 20px);
          margin-right: 10px;
          margin-left: 10px;
        }
        input {
            opacity: 0;
            position: absolute;
        }
        input:checked ~ button {
          background-color: var(--principal);
          color: #fff;
          span {
            span {
              color: #fff;
            }
          }
        }
        >div {
          margin-right: 20px;
        }
        label {
          display: flex;
          align-items: center;
          justify-content: center;
          input {
            margin: 0;
          }
          span {
            font-size: 1.37rem;
            font-weight: 500;
            padding: 5px 10px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            span {
              font-size: 1.5rem;
              font-weight: 700;
              color: var(--principal);
            }
          }
        }
      }
    }
  }
</style>
